export const FILE_TYPE:string[] = ["jpg", "jpeg", "png", "gif", "svg"];